/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { DashboardUser } from "./DashboardUser";
import {
  DashboardUserFromJSON,
  DashboardUserFromJSONTyped,
  DashboardUserToJSON,
  DashboardUserToJSONTyped,
} from "./DashboardUser";

/**
 *
 * @export
 * @interface UsersWithQuotedBookedInfo
 */
export interface UsersWithQuotedBookedInfo {
  /**
   *
   * @type {DashboardUser}
   * @memberof UsersWithQuotedBookedInfo
   */
  user: DashboardUser;
  /**
   *
   * @type {number}
   * @memberof UsersWithQuotedBookedInfo
   */
  quotedShipments: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof UsersWithQuotedBookedInfo
   */
  lastQuotedDate?: OffsetDateTime | null;
  /**
   *
   * @type {number}
   * @memberof UsersWithQuotedBookedInfo
   */
  bookedShipments: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof UsersWithQuotedBookedInfo
   */
  lastBookedDate?: OffsetDateTime | null;
}

/**
 * Check if a given object implements the UsersWithQuotedBookedInfo interface.
 */
export function instanceOfUsersWithQuotedBookedInfo(
  value: object,
): value is UsersWithQuotedBookedInfo {
  if (!("user" in value) || value["user"] === undefined) return false;
  if (!("quotedShipments" in value) || value["quotedShipments"] === undefined)
    return false;
  if (!("bookedShipments" in value) || value["bookedShipments"] === undefined)
    return false;
  return true;
}

export function UsersWithQuotedBookedInfoFromJSON(
  json: any,
): UsersWithQuotedBookedInfo {
  return UsersWithQuotedBookedInfoFromJSONTyped(json, false);
}

export function UsersWithQuotedBookedInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UsersWithQuotedBookedInfo {
  if (json == null) {
    return json;
  }
  return {
    user: DashboardUserFromJSON(json["user"]),
    quotedShipments: json["quotedShipments"],
    lastQuotedDate:
      json["lastQuotedDate"] == null ? undefined : json["lastQuotedDate"],
    bookedShipments: json["bookedShipments"],
    lastBookedDate:
      json["lastBookedDate"] == null ? undefined : json["lastBookedDate"],
  };
}

export function UsersWithQuotedBookedInfoToJSON(
  json: any,
): UsersWithQuotedBookedInfo {
  return UsersWithQuotedBookedInfoToJSONTyped(json, false);
}

export function UsersWithQuotedBookedInfoToJSONTyped(
  value?: UsersWithQuotedBookedInfo | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    user: DashboardUserToJSON(value["user"]),
    quotedShipments: value["quotedShipments"],
    lastQuotedDate: value["lastQuotedDate"],
    bookedShipments: value["bookedShipments"],
    lastBookedDate: value["lastBookedDate"],
  };
}
